import React from "react";
import AccountDetails from "./AccountDetails";
import AccountCurrentPosition from "./AccountCurrentPosition";
import AccountRecovery from "./accountRecovery";
import AccountExposure from "./AccountExposure";
import AccountSummaryCard from "./AccountSummaryCard";
import SidePeek from "../../../components/ui/sidepeek/SidePeek";
import AccountBorrowers from "./AccountBorrowers";
import BranchDetails from "./BranchDetails";

interface AccountSidePanelProps {
  accountNumber: string;
  onClose: () => void;
  onBorrowerClick: (stakeholderId: string) => void;
}

const Divider = () => <div className="h-px w-full shrink-0 bg-[#E5E5E5]" />;

const AccountSidePanel: React.FC<AccountSidePanelProps> = ({
  accountNumber,
  onClose,
  onBorrowerClick
}) => {
  return (
    <SidePeek title="Account Details" onClose={onClose}>
      <div className="my-4 flex w-full flex-col gap-6">
        <AccountSummaryCard accountNumber={accountNumber} />

        <AccountBorrowers
          accountNumber={accountNumber}
          onClick={onBorrowerClick}
        />


        <Divider />

        <AccountDetails accountNumber={accountNumber} />

        <Divider />

        <BranchDetails accountNumber={accountNumber} />

        <Divider />

        <AccountCurrentPosition accountNumber={accountNumber} />

        <Divider />

        <AccountExposure accountNumber={accountNumber} />

        <Divider />

        <AccountRecovery accountNumber={accountNumber} />
      </div>
    </SidePeek>
  );
};

export default AccountSidePanel;